import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollContextKey } from './scrollContext';

// ----------------------------------------------------------------------

/**
 * Sends the reader back to the top when they navigate somewhere new — but not
 * when they switch tabs on a page they are already reading. See
 * {@link scrollContextKey} for where that line is drawn.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const lastContext = useRef<string | null>(null);

  useEffect(() => {
    const context = scrollContextKey(pathname);
    // The first render counts as arriving: scroll, and remember where we are.
    if (lastContext.current !== context) {
      window.scrollTo(0, 0);
    }
    lastContext.current = context;
  }, [pathname]);

  return null;
}
